export default "__VITE_ASSET__Bq6Ag1Ac__"